/**
 * @desc OMS退货单创建逆向物流
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.LogisticsReverseLabelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/logisticsReverse/reverseLogistics`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
